<template>
    <div class="flex justify-center items-center w-full py-4 animate-fadeIn">
        <button
            @click="getNextHistory"
            class="group relative flex items-center gap-2 px-4 py-2.5 rounded-full
                   bg-white dark:bg-[#202c33] 
                   shadow-sm hover:shadow-md
                   border border-gray-200 dark:border-gray-700
                   transition-all duration-200 ease-out
                   hover:scale-[0.98] active:scale-95
                   focus:outline-none focus:ring-2 focus:ring-[#00a884]/30"
        >
            <!-- Icône avec cercle de fond -->
            <div class="flex items-center justify-center w-7 h-7 rounded-full 
                        bg-gray-100 dark:bg-[#2a3942]
                        group-hover:bg-[#00a884]/10 dark:group-hover:bg-[#00a884]/20
                        transition-colors duration-200">
                <i class="las la-arrow-up text-base font-bold 
                          text-gray-600 dark:text-gray-300
                          group-hover:text-[#00a884] dark:group-hover:text-[#00a884]
                          transition-colors duration-200"></i>
            </div>
            
            <!-- Texte -->
            <span class="text-sm font-medium 
                         text-gray-700 dark:text-gray-200
                         group-hover:text-gray-900 dark:group-hover:text-white
                         transition-colors duration-200">
                Anciens messages
            </span>

            <!-- Indicateur subtil au hover -->
            <div class="absolute inset-0 rounded-full 
                        bg-gradient-to-r from-[#00a884]/0 via-[#00a884]/5 to-[#00a884]/0
                        opacity-0 group-hover:opacity-100
                        transition-opacity duration-300
                        pointer-events-none"></div>
        </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "LoadMoreMessages",
    
    methods: {
        ...mapActions({
            getNextHistory: "messages/list/getNextHistory",
        }),
    }
}
</script>

<style scoped>
/* Animation d'entrée */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fadeIn {
    animation: fadeIn 0.4s ease-out;
}

/* Shadow personnalisée */
.shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.hover\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 
                0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
</style>